import { useIntl } from 'react-intl';
import { useSetState } from 'ahooks';
import * as SESSION_KEYS from '@/configs/session-storage-keys';
import { isUndefined, getSession } from '@/utils/common';
import { BSHHospitalCashProductKey } from '@/constants/productKey';
interface IReturn {
  continueButtonDisalbed: boolean;
  onChangeFormItem: (field: string, value: any) => any;
  visibilities: { [prop: string]: boolean };
  durationOptions: { label: string; value: string }[];
  isBSHHc: boolean;
}

interface IPrams {
  (values?: any): IReturn;
}

const useFormItemReaction: IPrams = (values = {}) => {
  const { formatMessage } = useIntl();
  const [formValues, setFormValues] = useSetState<any>(values);
  const isDurationUndefined = isUndefined(formValues?.policy_duration);
  const isInsuredNumUndefined = isUndefined(formValues?.insured_num);

  const planPicked = getSession(SESSION_KEYS.PICKED_PLAN_INFO);
  const isBSHHc = planPicked?.productKey === BSHHospitalCashProductKey;

  const continueButtonDisalbed = isBSHHc
    ? isInsuredNumUndefined
    : isDurationUndefined;

  const visibilities = {
    policyDuration: !isBSHHc,
    insuredNum: isBSHHc,
  };

  const durationOptions = [
    { label: formatMessage({ id: '3 Months' }), value: '3 Months' },
    { label: formatMessage({ id: '6 Months' }), value: '6 Months' },
    {
      label: formatMessage({ id: '12 Months' }),
      value: '12 Months',
    },
  ];

  const onChangeFormItem = (field: string, value: any) =>
    setFormValues({ [field]: value });

  return {
    continueButtonDisalbed,
    onChangeFormItem,
    visibilities,
    durationOptions,
    isBSHHc,
  };
};

export default useFormItemReaction;
